var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.295 25.6089H3V35.2114H6.29542C6.90958 35.2114 7.40583 34.7152 7.40583 34.1131V26.7189C7.40542 26.1048 6.90917 25.6089 6.295 25.6089ZM8.94083 27.286L13.3817 27.3214C15.8854 25.9748 17.1375 25.3018 17.1375 25.3018C25.2754 26.7664 29.35 27.4985 29.35 27.4985C30.7554 28.2781 30.85 29.0339 29.6688 30.0735C22.6767 30.0498 19.1925 30.1914 19.1925 30.1914C23.3146 31.9985 25.3225 32.9552 25.2042 33.0377C32.775 28.4077 36.5546 26.0927 36.5546 26.0927C38.0783 26.2106 38.3263 27.0377 37.6058 28.4193C29.0196 34.5381 24.7321 37.5852 24.7321 37.5852C20.5983 35.9314 16.8071 34.5735 13.37 33.4985C11.2675 33.5223 9.685 33.5339 8.94083 33.5456V27.286ZM25.1575 3.41602L25.8663 5.60102H28.1575L26.3033 6.94768L27.0121 9.12102L25.1579 7.77477L23.3038 9.12102L24.0242 6.94768L22.1579 5.60102H24.4613L25.1575 3.41602ZM34.0867 7.69143L34.9963 10.5377H37.9963L35.575 12.2856L36.4963 15.1319L34.0867 13.3719L31.6654 15.1319L32.5983 12.2856L30.1654 10.5377H33.1654L34.0867 7.69143ZM25.4292 15.0498C29.055 15.0498 31.9963 17.9906 31.9963 21.6168C31.9963 23.5302 31.1696 25.2548 29.8704 26.4477C29.3154 26.2352 20.8942 24.9123 19.5596 24.5581C19.1225 23.6723 18.8629 22.6685 18.8629 21.6173C18.8621 17.9906 21.8029 15.0498 25.4292 15.0498ZM21.2242 23.3885C20.9879 23.1639 20.9763 22.7981 21.1888 22.5618C21.4133 22.3256 21.7792 22.3139 22.0154 22.5381L23.48 23.8964C23.6571 24.0498 23.9408 24.0973 24.0825 23.9435L28.795 18.2389C28.9958 17.991 29.3621 17.9556 29.61 18.1681C29.8579 18.3689 29.8933 18.7352 29.6925 18.9831L24.9921 24.6756C24.4133 25.3723 23.3383 25.3489 22.6888 24.7464L21.2242 23.3885Z",
    fill: "url(#paint0_linear_13711_111374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4026 8.07043C17.4026 9.81256 15.9903 11.2248 14.2482 11.2248C12.506 11.2248 11.0938 9.81256 11.0938 8.07043C11.0938 6.32829 12.506 4.91602 14.2482 4.91602C15.9903 4.91602 17.4026 6.32829 17.4026 8.07043Z",
    fill: "url(#paint1_linear_13711_111374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.666C11 12.8711 12.4551 11.416 14.25 11.416C16.0449 11.416 17.5 12.8711 17.5 14.666V17.916H11V14.666Z",
    fill: "url(#paint2_linear_13711_111374)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13711_111374",
    x1: 3,
    y1: 20.5006,
    x2: 37.9963,
    y2: 20.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13711_111374",
    x1: 11.0938,
    y1: 8.07043,
    x2: 17.4026,
    y2: 8.07043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13711_111374",
    x1: 11,
    y1: 14.666,
    x2: 17.5,
    y2: 14.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassTeacher);
export default __webpack_public_path__ + "static/media/Class_Teacher.6c693e714967bfa35b4d6b4f09385c22.svg";
export { ForwardRef as ReactComponent };